import React, { MouseEventHandler } from 'react';
import classnames from 'classnames';

import styles from './index.module.css';

type PageWrapperProps = {
	className?: string;
	withHeader?: boolean;
	withMinViewHeight?: boolean;
	backgroundColor?: 'white' | 'background';
	children: React.ReactNode;
	onContextMenu?: MouseEventHandler<HTMLDivElement>;
	preventTouch?: boolean;
};

const PageWrapper = ({
	className,
	withHeader = true,
	withMinViewHeight = true,
	backgroundColor = 'background',
	children,
	onContextMenu,
	preventTouch,
}: PageWrapperProps) => {
	const preventDefault = (event: React.TouchEvent<HTMLDivElement>) => {
		event.preventDefault();
		return false;
	};

	return (
		<div
			className={classnames(
				styles.pageWrapper,
				withHeader && styles.withHeader,
				withMinViewHeight && styles.minViewHeight,
				backgroundColor && styles[backgroundColor],
				className,
			)}
			onContextMenu={onContextMenu}
			onTouchStart={e => (preventTouch ? preventDefault(e) : undefined)}
			onTouchEnd={e => (preventTouch ? preventDefault(e) : undefined)}
			onTouchMove={e => (preventTouch ? preventDefault(e) : undefined)}
			onTouchCancel={e => (preventTouch ? preventDefault(e) : undefined)}
		>
			{children}
		</div>
	);
};

export default PageWrapper;

type SectionWrapperProps = {
	className?: string;
	wrapperClassName?: string;
	overflowHidden?: boolean;
	withoutMargin?: boolean;
	withoutPadding?: boolean;
	withMaxViewWidth?: boolean;
	children: React.ReactNode;
};

export const SectionWrapper = ({
	className,
	wrapperClassName,
	overflowHidden = false,
	withoutMargin = false,
	withoutPadding = false,
	withMaxViewWidth = false,
	children,
}: SectionWrapperProps) => (
	<section
		className={classnames(
			styles.sectionWrapper,
			overflowHidden && styles.overflowHidden,
			withoutMargin && styles.withoutMargin,
			withoutPadding && styles.withoutPadding,
			withMaxViewWidth && styles.maxViewWidth,
			className,
		)}
	>
		<div className={classnames(styles.wrapper, wrapperClassName)}>{children}</div>
	</section>
);
